<script>
  import { DateTime } from 'luxon';
  import Days from './Components/Days.svelte';
  import Block from './Components/Block.svelte';
  import Reservation from './Components/Reservation.svelte';
	import { User } from '../../store.js';	
	
  export let property;
  export let dateRange;
	export let reservations;
	export let blocks;
	export let grid;
	export let currency = '';
  export let markupPercentage;
	
	let user;
	const unUser = User.subscribe(v => user = v);

  $: _grid = test(grid);

  const test = (grid) => {
    return grid.map((item) => {
      return item;
    });
  }
	
	let blockGroups = condenseBlocks(blocks);
  function condenseBlocks(blocks){
    console.log('blocks');
    console.log(blocks);
		let blockGroups = [];
    let checker = false;
		for(let i = 0;i<blocks.length;i++){
			let block = blocks[i];
      
      if(i > 0 )
      {

      if( i< blocks.length -1)
      {
        if(blocks[i+1].dateInserted === block.dateInserted )
        {
          
          let today = DateTime.fromISO(block.day).toMillis();
          let NextDay = DateTime.fromISO(blocks[i+1].day).toMillis();
          if(NextDay - today > 86400000 || checker)
          {
            checker = true;
            let NewInsertedDate = DateTime.fromISO(blocks[i+1].dateInserted).toMillis() + 100;
            blocks[i+1].dateInserted = DateTime.fromMillis(NewInsertedDate,{zone:'UTC'}).toISO();
          
          }

        }
      }
      
      if(i === blocks.length -1)
          {
              let NewInsertedDate = DateTime.fromISO(block.dateInserted).toMillis() + 100;
              block.dateInserted = DateTime.fromMillis(NewInsertedDate,{zone:'UTC'}).toISO();
          }
      }
      
		 if(!blockGroups[block.dateInserted]){
				blockGroups[block.dateInserted] = [];
			}
			blockGroups[block.dateInserted].push(block);
		};
    console.log('blockGroups');
    console.log(blockGroups);
		let insertDates = Object.keys(blockGroups);
		let blockGroups2 = insertDates.map(date => {
			let group = blockGroups[date];
			let groupDates = group.map(b => DateTime.fromISO(b.day).toMillis());
      console.log(groupDates);
			let dateFrom = DateTime.fromMillis(Math.min(...groupDates),{zone:'UTC'}).toISO();
      let dateTo = DateTime.fromMillis(Math.max(...groupDates),{zone:'UTC'}).plus({days:1}).toISO();

			
			return {
				dateFrom,
				dateTo,
				blockType : group[0].blockType,
				blockReason : group[0].blockReason,
				owner : group[0].owner,
				nights : group.length,
				dateInserted : date
			}
		})
    console.log('blockGroups2');
    console.log(blockGroups2);
		return blockGroups2;
    
	}
	
  const preRender = (calendarItems) => {
    const helper = {
      rows: 1,
      data: []
    };

    calendarItems.forEach(item => {
      // The cleaner shows only one row
      if (user.accountRole.toLowerCase() !== 'cleaner') {
        item.overlaps = [];

        helper.data.forEach((prerendered) => {
          if (isOverlaping(item, prerendered) || isOverlaping(prerendered, item)) {
            // Add the element that is overlaping
            item.overlaps.push(prerendered.row);

            // how many rows is overlaping
            const rowLen = item.overlaps.length;
            let goDown = true; // Can we create a new row?

            // Check that we are overlaping all rows
            for (let i = 1; i <= rowLen; i++) {
              // If there is one available row, select it
              if (item.overlaps.indexOf(i) === -1) {
                item.row = i;
                goDown = false;
                break;
              }
            }

            // If we need to create a new row
            if (goDown) {
              item.row = rowLen + 1;
            }

            // Update the new max rows
            if (item.row > helper.rows) {
              helper.rows = item.row;
            }
          }
        });
      }

      if (!item.row) {
        item.row = 1;
      }
      
      helper.data.push(item);
    });

    return helper;
  }

  const isOverlaping = (item1, item2) => {
    const reservation = {
      from: getDate(item1.dateFrom), to: getDate(item1.dateTo),
    };

    const prerendered = {
      from: getDate(item2.dateFrom), to: getDate(item2.dateTo)
    };

    if (reservation.from >= prerendered.from && reservation.from < prerendered.to) {
      return true;
    }

    if (reservation.to > prerendered.from && reservation.to <= prerendered.to) {
      return true;
    }

    return false;
  };

  const getDate = (date) => {
    return DateTime.fromISO(date, { setZone: true });
  }

  const itemsToPrerender = [];

  blockGroups.forEach(block => {
    if (block.blockType !== 'reservation') {
      block.renderType = 'block';
      itemsToPrerender.push(block);
    }
  });

  reservations.forEach(reservation => {
    reservation.renderType = 'reservation';
    itemsToPrerender.push(reservation);
  });

  const render = preRender(itemsToPrerender);
</script>
<div class='grid' class:cleaner='{user.accountRole.toLowerCase() === 'cleaner'}' style='height: {render.rows * 50}px;'>
  <Days property={property} dateRange={dateRange} grid={grid} blocks={blocks} currency={currency} user={user} height={render.rows * 50} 
    markupPercentage={markupPercentage}
  />

  {#each render.data as item}
    {#if item.renderType == 'block'}
      <Block block={item} grid={_grid} user={user} />
    {:else}
      <Reservation reservation={item} grid={grid} user={user} />
    {/if}
  {/each}
</div>
<style>
	.grid{
		display: flex;
		position: relative;
		overflow: hidden;
	}
</style>